<template>
  <footer v-if="this.FooterData">
    <!-- 尾 -->
    <div class="container">
      <a href="#" class="sr-only sr-only-focusable" id="AB" accesskey="B" name="B" title="下方功能區塊"><img
          src="img/icon-circle.svg" alt=""></a>
      <div class="text-box" v-html="this.FooterData.Footer_Text">
      </div>
    </div>
    <div class="bottom">
      <p>Copyright © 2022 Tainan City Government.</p>
    </div>
  </footer>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueAxios, axios);

export default {
  name: "Footer",
  data() {
    return {
      FooterData: {},
    };
  },
  created: function () {
    Vue.axios
      .get(
        this.$store.state.src + this.$store.state.subDirectory + "/Html/Footer",
        {
          params: {},
        }
      )
      .then((response) => {
        this.FooterData = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
